import ApiBaseUrl from './http-api-base-url'
import axios from 'axios';

export default ({ requiresAuth = false } = {}) => {
  const options = {};
  options.baseURL = ApiBaseUrl();

  if (requiresAuth) {
    options.headers.Authorization = ''
  }
  const instance = axios.create(options);

  instance.interceptors.response.use(response => {
    return response;
  }, error => {
    return Promise.reject(error);
  });
  return instance;
};